<template>
	<b-modal
		id="deleteModal"
		centered
		hide-footer
		hide-header
		v-model="showModal"
		@hidden="$emit('close-modal')"
	>
		<div class="d-flex">
			<div class="w-100">
				<div
					class="candash-modal-top no-border-bottom profiles-flex-column p-3"
				>
					<div class="pro-width-10">
						<img
							class="mr-3"
							src="@/assets/icons/candDashboard/modalDelete.svg"
							alt=""
						/>
					</div>
					<div class="pro-pl-3">
						<div class="d-flex justify-content-between">
							<div class="candash-modal-head pro-text-center">
								Delete {{ deleteContent.name }}
							</div>

							<div
								class="d-flex justify-content-end pointer cross-icon-pos"
								@click="$emit('close-modal')"
							>
								<img
									class="rotate-on-hover"
									src="@/assets/newdesign/dashboard/blueCross.svg"
									alt=""
								/>
							</div>
						</div>
						<div class="candash-modal-label mt-2 pr-3 pro-text-center">
							Are you sure you want to delete this
							{{ deleteContent.name }}? This action cannot be undone.
						</div>
					</div>
				</div>

				<div
					class="p-3 no-border-top d-flex align-items-center justify-content-end gap-4"
				>
					<b-button
						class="candash-cancelBtn pro-w-50 pointer"
						@click="$emit('close-modal')"
						>Cancel</b-button
					>
					<div class="position-relative pro-w-50">
						<b-button
							class="candash-addBtn pro-w-100"
							:class="
								!isNoDelete
									? '  loader-class-delete defaultCursor '
									: ' pointer'
							"
							@click="isNoDelete ? deleteData() : ''"
							>{{ !isNoDelete ? "" : "Delete" }}</b-button
						>
						<div v-if="!isNoDelete" class="loader-pos-new">
							<Loader />
						</div>
					</div>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
import Loader from "../fixedcomponents/Loader.vue";
import { mapGetters } from "vuex";
import toast from "../mixin/toast";
import {
	deleteCandAchieve,
	deleteCandAward,
	deleteCandEdu,
	deleteCandEvent,
	deleteCandExp,
	deleteCandProject,
	deleteCandskills,
	postCandInfo,
	postCandInterSkills,
	postCandSkills,
} from "@/utils/apiFunctions";
export default {
	name: "DeleteModal",
	props: {
		showModal: Boolean,
		deleteContent: Object,
		selectedForm: Object,
	},
	mixins: [toast],
	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
		}),
	},
	components: {
		Loader,
	},
	data() {
		return {
			isNoDelete: true,
		};
	},
	methods: {
		deleteData() {
			this.isNoDelete = false;
			console.log(this.candidateInfo);

			let payload = {
				email: this.candidateInfo.email,
				priorityID: this.deleteContent.priorityID,
				id: this.candidateInfo._id,
			};

			if (this.deleteContent.parser) {
				delete payload.priorityID;
				payload.parser = this.deleteContent.id;
			}
			let funcName = "delete" + this.selectedForm.formID;
			console.log(funcName);

			this[funcName](payload);
		},
		async deleteeducation(payload) {
			try {
				const response = await deleteCandEdu(payload);
				if (response.status == 200) {
					this.afterDelete();
				} else {
					this.isNoDelete = true;
					this.errorModal("Error", "Something went wrong");
				}
			} catch (error) {
				this.isNoDelete = true;
				console.log(error);
			}
		},
		async deleteexperience(payload) {
			try {
				const response = await deleteCandExp(payload);
				if (response.status === 200) {
					this.afterDelete();
				} else {
					this.isNoDelete = true;
					this.errorModal("Error", "Something went wrong");
				}
			} catch (error) {
				this.isNoDelete = true;
				console.log(error);
			}
		},
		async deleteproject(payload) {
			try {
				const response = await deleteCandProject(payload);
				if (response.status === 200) {
					this.afterDelete();
				} else {
					this.isNoDelete = true;
					this.errorModal("Error", "Something went wrong");
				}
			} catch (error) {
				this.isNoDelete = true;
				console.log(error);
			}
		},
		async deleteachievement(payload) {
			try {
				var response;
				if (this.deleteContent.achieveType == "award") {
					response = await deleteCandAward(payload);
				} else if (this.deleteContent.achieveType == "event") {
					response = await deleteCandEvent(payload);
				} else {
					response = await deleteCandAchieve(payload);
				}
				if (response.status === 200) {
					this.afterDelete();
				} else {
					this.isNoDelete = true;
					this.errorModal("Error", "Something went wrong");
				}
			} catch (error) {
				this.isNoDelete = true;
				console.log(error);
			}
		},
		async deleteskills(payload) {
			try {
				let data = payload;
				const cleanUpUniqueID = (data2) => {
					data2.skills?.forEach((obj) => delete obj.uniqueID);
					data2.interpersonalSkills?.forEach((obj) => delete obj.uniqueID);
				};
				if (
					this.deleteContent.uniqueID.includes("SKILL") &&
					!this.deleteContent.uniqueID.includes("INTERPERSONALSKILL")
				) {
					let skills = this.candidateInfo.skills.filter((data) => {
						return data.uniqueID != this.deleteContent.uniqueID;
					});
					delete data.priorityID;
					data.skills = skills;
					cleanUpUniqueID(data);
					const response = await postCandSkills(data);
					if (response.status == 200) {
						this.afterDelete();
					} else {
						this.isNoDelete = true;
						this.errorModal("Error", "Something went wrong");
					}
				} else if (
					/^INTERPERSONALSKILL\d*$/.test(this.deleteContent.uniqueID)
				) {
					let interpersonalSkills =
						this.candidateInfo.interpersonalSkills.filter((data) => {
							return data.uniqueID != this.deleteContent.uniqueID;
						});
					delete data.priorityID;
					data.interpersonalSkills = interpersonalSkills;
					cleanUpUniqueID(data);

					const response = await postCandInterSkills(data);
					if (response.status == 200) {
						this.afterDelete();
					} else {
						this.isNoDelete = true;
						this.errorModal("Error", "Something went wrong");
					}
				}
			} catch (error) {
				this.isNoDelete = true;
				console.log(error);
			}
		},
		async deletehobbies(payload) {
			try {
				let data = payload;
				delete data.priorityID;
				if (!this.deleteContent.isParser) {
					let hobbies = this.candidateInfo.hobbies.filter((data) => {
						return data != this.deleteContent.hobby;
					});
					data.hobbies = hobbies;
				} else {
					let parserHobbies = this.candidateInfo.parserHobbies.filter(
						(data) => {
							return data != this.deleteContent.hobby;
						}
					);
					data.parserHobbies = parserHobbies;
				}

				const response = await postCandInfo(data);
				if (response.status == 200) {
					this.afterDelete();
				} else {
					this.isNoDelete = true;
					this.errorModal("Error", "Something went wrong");
				}
			} catch (error) {
				this.isNoDelete = true;
				console.log(error);
			}
		},

		afterDelete() {
			if (this.$route.name == "CandidateDashboard") {
				this.$emit("profile-complition");
				this.$emit("get-profile-details");
			} else {
				this.$emit("get-all-data");
			}
			this.$emit("close-modal");
			this.isNoDelete = true;
			this.$nextTick(() => {
				let name =
					this.selectedForm.formID.charAt(0).toUpperCase() +
					this.selectedForm.formID.slice(1);
				this.successModal("Successfully deleted", `${name} has been deleted`);
			});
		},
	},
};
</script>

<style></style>
